document.addEventListener('click', function(e) {
  'use strict';

  const toggle = e.target.closest('[data-reporting-persons-toggle]');
  if (!toggle) return;

  const expanded = toggle.getAttribute('aria-expanded') === 'true';
  toggle.setAttribute('aria-expanded', String(!expanded));

  document.querySelectorAll(`[data-reporting-persons="${toggle.dataset.reportingPersonsToggle}"]`).forEach(function(row) {
    row.hidden = expanded;
  });
});
